import { Tooltip } from "react-tooltip";
import { CheckCircleIcon, NoSymbolIcon } from "@heroicons/react/24/outline";
import Select from "../../../components/input/Select";
import { CourseStatus } from "../../courses/coursesApiSlice";
import CourseReports from "../course/CourseReports";
import { useAdminReportsFilters } from "./useAdminReportsFilters";
import { DistrictSchoolFilters } from "./DistrictSchoolFilters";

export default function AdminCourseLevelReports() {
	const {
		districtOptions,
		schoolOptions,
		teacherOptions,
		courseOptions,
		districtFilter,
		schoolFilter,
		teacherFilter,
		courseFilter,
		setDistrictFilter,
		setSchoolFilter,
		setTeacherFilter,
		setCourseFilter,
	} = useAdminReportsFilters();

	return (
		<section>
			<div className="my-4 flex gap-3 items-end w-fit print:hidden">
				<DistrictSchoolFilters
					districtOptions={districtOptions}
					schoolOptions={schoolOptions}
					districtFilter={districtFilter}
					schoolFilter={schoolFilter}
					setDistrictFilter={setDistrictFilter}
					setSchoolFilter={setSchoolFilter}
					labelClasses="!text-lg"
					listBoxClasses="w-80"
				/>
				{teacherOptions.length > 0 && (
					<Select
						value={teacherFilter}
						setValue={(v) => setTeacherFilter(v as number)}
						label="Teacher"
						simpleListBoxId="teacherFilter"
						options={teacherOptions}
						labelClasses="!text-lg"
						fieldClasses="w-full md:flex-1 pt-2 md:pt-0"
						simpleListBoxClasses="w-80"
					/>
				)}
			</div>
			{courseOptions.length !== 0 ? (
				<div className="flex p-4 mt-4 bg-gray-50/10 border border-gray-200 rounded-lg">
					<div className="flex flex-col w-1/4 gap-y-3 border-r border-gray-200 pr-4 pl-2">
						<h2>Courses</h2>
						<ul role="list" className="flex flex-1 flex-col pl-3 pr-2 space-y-1">
							{courseOptions.map((course) => {
								return (
									<li key={course.courseId}>
										<a
											onClick={() => setCourseFilter(course.courseId)}
											className={`${
												courseFilter === course.courseId
													? "bg-gray-100/80 text-primary-700 font-semibold"
													: "text-gray-700 hover:bg-gray-100/80 hover:text-primary-700 font-medium"
											} group flex gap-x-3 rounded-md p-2 text-sm cursor-pointer`}>
											<span className="flex items-center gap-x-2">
												{course.courseStatus === CourseStatus.Open ? (
													<CheckCircleIcon
														className="size-6 text-green-500 shrink-0"
														data-tooltip-id={`status-${course.courseId}-tooltip`}
													/>
												) : (
													<NoSymbolIcon
														className="size-6 text-red-500 shrink-0"
														data-tooltip-id={`status-${course.courseId}-tooltip`}
													/>
												)}
												<Tooltip
													id={`status-${course.courseId}-tooltip`}
													place="top-start"
													content={`${course.courseStatus}`}
												/>
												{course.courseName}
											</span>
										</a>
									</li>
								);
							})}
						</ul>
					</div>

					<div className="w-3/4 px-8">
						<h2>
							Course Reports -{" "}
							{courseOptions.find((c) => c.courseId === courseFilter)?.courseName}
						</h2>
						<CourseReports courseId={courseFilter} />
					</div>
				</div>
			) : (
				<div className="px-4 py-8 bg-gray-50 border border-gray-200 rounded-lg">
					<p className="text-gray-700 text-center">
						{schoolOptions.length === 0
							? "Reports are not enabled. Please contact the MI Write team to enable reports for you."
							: schoolFilter === 0
								? "Select a school to be able to view course-level reports."
								: teacherOptions.length === 0
									? "There are no teachers in the school to view a course-level report for."
									: "The selected teacher is not registered in any courses in the school."}
					</p>
				</div>
			)}
		</section>
	);
}
